export default "__VITE_ASSET__EiA8K1rW__"